import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/accordions/FaqFullPage.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/gitbiz/procuct/features/LeaveMainFeatures.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/gitbiz/procuct/features/LeaveMSTestimonials.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/gitbiz/procuct/HrmsPricing.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/others/ClientSlider.jsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/img/product/hrms/employeems/bg1.webp");
